// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"01328d27","598":"580fae73","703":"43146307","787":"3e24d16c"}[chunkId] + ".chunk.js";
};